import { useEffect } from "react";
import useBranchId from "../hooks/useBranchId";
import usePrinterSettingsHook from "../hooks/usePrinterSettingsHook";

const useHasKioskPrinter = () => {
  const branch = useBranchId();
  const { getPrinterSettings } = usePrinterSettingsHook();
  useEffect(() => {
    getPrinterSettings.refetch();
  }, [branch]);

  useEffect(() => {
    getPrinterSettings.refetch();
  }, []);

  console.log(
    Object.keys(getPrinterSettings?.data?.printers || {}).length !== 0 ||
      getPrinterSettings.data?.isActive === true
  );

  if (getPrinterSettings.isSuccess) {
    return (
      Object.keys(getPrinterSettings?.data?.printers || {}).length !== 0 ||
      getPrinterSettings.data?.isActive === true
    );
  }

  return true;
};

export default useHasKioskPrinter;
